"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.modifyOptions = exports.numberOptions = exports.optionsWithSections = exports.optionsWithIconAndSubtitles = exports.optionsWithIcon = exports.optionsWithUnavailableItems = exports.optionsWithSubtitle = exports.simpleOptions = void 0;
exports.simpleOptions = new Array(6).fill(null).map(function (el, i) {
    return i === 4
        ? { divider: true }
        : {
            id: "" + i,
            value: "Input Text " + (i + 1),
            isSelectable: i < 3,
        };
});
exports.optionsWithSubtitle = exports.simpleOptions.map(function (option, i) { return (__assign(__assign({}, option), { subtitle: i === 0
        ? "The longest subtitle has 2 lines. Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book."
        : "Subtitle Text " + i })); });
exports.optionsWithUnavailableItems = [
    {
        id: '0',
        value: 'Site Pages (selectable)',
        isSelectable: true,
    },
    {
        id: '1',
        value: 'Home (not selectable)',
        isSelectable: false,
    },
    {
        id: '2',
        value: 'Shop (unavailable)',
        unavailable: true,
    },
];
exports.optionsWithIcon = "[{\n    id: '1',\n    value: 'Share 01',\n    isSelectable: true,\n    icon: " + "<svg width=\"24px\" height=\"24px\">\n        <path d=\"M14.2736842,7.11666667 C12.1894737,7.21111111 3.66315789,8.62777778 3,21 C4.51578947,17.2222222 8.11578947,14.6722222 12.1894737,14.6722222 C12.8526316,14.6722222 13.5157895,14.7666667 14.2736842,14.8611111 L14.2736842,18.1666667 L21,11.0833333 L14.2736842,4 L14.2736842,7.11666667 Z\"/>\n    </svg>" + "\n}, {\n    id: '2',\n    value: 'Share 02',\n    isSelectable: true,\n    icon: " + "<svg width=\"24px\" height=\"24px\">\n        <path d=\"M14.2736842,7.11666667 C12.1894737,7.21111111 3.66315789,8.62777778 3,21 C4.51578947,17.2222222 8.11578947,14.6722222 12.1894737,14.6722222 C12.8526316,14.6722222 13.5157895,14.7666667 14.2736842,14.8611111 L14.2736842,18.1666667 L21,11.0833333 L14.2736842,4 L14.2736842,7.11666667 Z\"/>\n    </svg>" + "\n}]";
exports.optionsWithIconAndSubtitles = "[{\n    id: '1',\n    value: 'Share 01',\n    subtitle: 'Subtitle Share 01',\n    isSelectable: true,\n    icon: " + "<svg width=\"24px\" height=\"24px\">\n        <path d=\"M14.2736842,7.11666667 C12.1894737,7.21111111 3.66315789,8.62777778 3,21 C4.51578947,17.2222222 8.11578947,14.6722222 12.1894737,14.6722222 C12.8526316,14.6722222 13.5157895,14.7666667 14.2736842,14.8611111 L14.2736842,18.1666667 L21,11.0833333 L14.2736842,4 L14.2736842,7.11666667 Z\"/>\n    </svg>" + "\n}, {\n    id: '2',\n    value: 'Share 02',\n    subtitle: 'Subtitle Share 02',\n    isSelectable: true,\n    icon: " + "<svg width=\"24px\" height=\"24px\">\n        <path d=\"M14.2736842,7.11666667 C12.1894737,7.21111111 3.66315789,8.62777778 3,21 C4.51578947,17.2222222 8.11578947,14.6722222 12.1894737,14.6722222 C12.8526316,14.6722222 13.5157895,14.7666667 14.2736842,14.8611111 L14.2736842,18.1666667 L21,11.0833333 L14.2736842,4 L14.2736842,7.11666667 Z\"/>\n    </svg>" + "\n}]";
exports.optionsWithSections = [
    {
        id: '0',
        value: 'Site Pages',
        isSectionTitle: true,
        isSelectable: false,
    },
    {
        id: '1',
        value: 'Home',
        isSelectable: true,
    },
    {
        id: '2',
        value: 'Shop',
        isSelectable: true,
    },
    {
        id: '3',
        value: 'About',
        isSelectable: true,
    },
    {
        id: '4',
        value: 'Blog Posts',
        isSectionTitle: true,
        isSelectable: false,
    },
    {
        id: '5',
        value: '11 Proven Ways to Monetize a Website',
        isSelectable: true,
    },
];
exports.numberOptions = new Array(6).fill(null).map(function (el, i) { return ({
    id: "" + i,
    value: "0" + (i + 1),
    isSelectable: true,
}); });
exports.modifyOptions = function (options) {
    return options.map(function (option) {
        return option.unavailable
            ? __assign(__assign({}, option), { isSelectable: option.isSelectable === undefined ? true : option.isSelectable }) : option;
    });
};
//# sourceMappingURL=helpers.js.map